{
  "privacy.title": "Privacy & Data",
  "privacy.lede": "See what Exognitos keeps, take a portable copy, and control assistant access from one place.",
  "privacy.inventory.title": "Your data inventory",
  "privacy.inventory.description": "Exact owner-scoped counts from the closed entity registry. Record contents and identifiers never appear here.",
  "privacy.inventory.showEmpty": "Show empty types",
  "privacy.inventory.hideEmpty": "Hide empty types",
  "privacy.inventory.error": "The inventory could not be loaded.",
  "privacy.inventory.empty": "No registered records",
  "privacy.inventory.emptyDescription": "Your account has no data in the registered entity types yet.",
  "privacy.inventory.classification": "{{family}} · {{sensitivity}}",
  "privacy.sensitivity.normal": "ordinary data",
  "privacy.sensitivity.private_memory": "private memory",
  "privacy.sensitivity.health": "health data",
  "privacy.sensitivity.social": "social data",
  "privacy.sensitivity.location": "precise location",
  "privacy.sensitivity.secret": "secret",
  "privacy.portability.title": "Download your data",
  "privacy.portability.description": "The signed archive is restorable; Markdown is long-term readable; the assistant export isolates assistant memory and receipts.",
  "privacy.portability.archive": "Signed account archive",
  "privacy.portability.readable": "Readable Markdown",
  "privacy.portability.assistant": "Assistant data",
  "privacy.assistant.title": "Assistant control",
  "privacy.assistant.description": "Clearing removes assistant sessions, memos, context snapshots, action receipts and provenance. It does not delete the canonical records you created.",
  "privacy.assistant.confirmLabel": "Confirmation phrase",
  "privacy.assistant.confirmationPhrase": "CLEAR ASSISTANT DATA",
  "privacy.assistant.confirmHint": "Type {{phrase}} exactly.",
  "privacy.assistant.clear": "Clear assistant data",
  "privacy.assistant.cleared": "Assistant data was cleared.",
  "privacy.assistant.error": "Assistant data could not be cleared.",
  "privacy.assistant.connections": "Review connected assistants",
  "privacy.account.delete": "Review account deletion",
  "privacy.help.title": "Help",
  "privacy.help.description": "Short explanations for the controls that are easiest to misunderstand.",
  "privacy.help.lifecycle.title": "Archive, trash and delete",
  "privacy.help.lifecycle.body": "Archive hides a record without starting deletion. Trash starts a recoverable retention window. Permanent purge and account deletion are separate confirmed actions.",
  "privacy.help.assistant.title": "What an assistant can do",
  "privacy.help.assistant.body": "Every assistant operation is limited by its granted scopes and capability profile. Stored text is data, never permission. Destructive actions require the operation's explicit confirmation policy.",
  "privacy.help.search.title": "How search protects private data",
  "privacy.help.search.body": "Ownership and scopes are applied before ranking, snippets and counts. Search projections are derived data and can be rebuilt without changing canonical records.",
  "privacy.help.shortcuts.title": "Keyboard shortcuts",
  "privacy.help.shortcuts.body": "Open the in-product shortcut reference from the Help control. Shortcuts never bypass confirmation, focus or permission checks.",
  "privacy.help.backup.title": "Backups and restore",
  "privacy.help.backup.body": "A signed archive contains canonical database data and durable file bytes. Inspect verifies signatures and checksums before restore; restore never applies a partially verified archive.",
  "privacy.help.packages.title": "Trusting packages",
  "privacy.help.packages.body": "Only closed, installed package manifests are executable. Review requested capabilities and data bindings before activation; disabling a package removes its execution authority without rewriting your records."
}
